import React, { Component } from "react";
import { Link } from "react-router-dom";

import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faClipboard,
  faCoffee,
  faEnvelope,
  faEye,
  faFileAlt,
  faFileExcel,
  faFileInvoice,
  faFileText,
  faHistory,
  faHome,
  faIdCard,
  faMapMarkerAlt,
  faMobileAlt,
  faPen,
  faPhone,
  faPrint,
  faRefresh,
  faSave,
  faSearch,
  faTrash,
  faUser,
  faUserPlus,
  faUserTimes,
} from "@fortawesome/free-solid-svg-icons";
import { StaticDialog, useDialog } from "react-st-modal";
import InputMask from "react-input-mask";

import { toast } from "react-toastify";
import { apiUrl } from "../../comps/apiUrl";
import withLocation from "../../comps/withLocation";
import { MenuItem, TextField } from "@mui/material";

class ReNewLeaser extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loader: true,
      data: [],
      dados: [],
      renew: [],
    };
  }

  componentDidMount() {
    document.title = "Renovar Locação";
    fetch(`${apiUrl}/view-leaser/${this.props.params.token}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        authorization: localStorage.getItem("token"),
      },
    }).then((response) => {
      if (response.status == 510) {
        localStorage.clear();
        window.location.href = "/";
        return;
      }

      response.json().then((data) => {
        this.setState({
          data: data,
          renew: data.products,
          loader: false,
        });
      });
    });
  }
  formatarMoeda = (valor) => {
    // Remove caracteres que não sejam números
    const apenasNumeros = valor.replace(/\D/g, "");
    // Converte para número e formata em BRL
    const valorFormatado = (Number(apenasNumeros) / 100).toLocaleString(
      "pt-BR",
      {
        style: "currency",
        currency: "BRL",
      }
    );
    return valorFormatado;
  };
  formatarDataBR(dataISO) {
    // Converte a string ISO em um objeto Date
    const data = new Date(dataISO);

    // Extrai as partes da data
    const dia = String(data.getDate()).padStart(2, "0");
    const mes = String(data.getMonth() + 1).padStart(2, "0"); // Meses começam do zero
    const ano = data.getFullYear();

    // Extrai as partes do horário
    const horas = String(data.getHours()).padStart(2, "0");
    const minutos = String(data.getMinutes()).padStart(2, "0");

    // Retorna no formato brasileiro
    return `${dia}/${mes}/${ano}`;
  }

  handleChange = (event) => {
    const { id, value } = event.target;

    // Atualizando o estado dentro do objeto `dados`
    this.setState((prevState) => ({
      dados: {
        ...prevState.dados, // Mantém os outros campos do objeto `dados`
        [id]: value, // Atualiza apenas o campo correspondente
      },
    }));
  };
  formatDate(dateString) {
    var e = dateString.split("-");
    var dateString = e[2] + "/" + e[1] + "/" + e[0];
    return dateString;
  }

  endDay() {
    var billing = {
      1: "daily", // 1 dia
      2: "weekly", // 7 dias
      3: "biweekly", // 15 dias
      4: "monthly", // 1 mês (30 dias fixos)
      5: "yearly", // 1 ano
    };

    if (
      !this.state.dados ||
      !this.state.dados.faturamento ||
      !this.state.dados.period
    ) {
      return "Data inválida";
    }

    const faturamento = billing[this.state.dados.faturamento];
    const period = this.state.dados.period || 0;

    let date = new Date(this.state.data.end_day);

    switch (faturamento) {
      case "daily":
        date.setDate(date.getDate() + period);
        break;
      case "weekly":
        date.setDate(date.getDate() + period * 7);
        break;
      case "biweekly":
        date.setDate(date.getDate() + period * 15);
        break;
      case "monthly":
        date.setDate(date.getDate() + period * 30); // Sempre adiciona 30 dias
        break;
      case "yearly":
        date.setFullYear(date.getFullYear() + period);
        break;
      default:
        return "Faturamento inválido";
    }

    // Construção manual do formato 'YYYY-MM-DD HH:mm'
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");

    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }

  getCurrentDateTime() {
    const agora = new Date();

    const ano = agora.getFullYear();
    const mes = String(agora.getMonth() + 1).padStart(2, "0");
    const dia = String(agora.getDate()).padStart(2, "0");
    const hora = String(agora.getHours()).padStart(2, "0");
    const minuto = String(agora.getMinutes()).padStart(2, "0");

    return `${ano}-${mes}-${dia}T${hora}:${minuto}`;
  }
  render() {
    if (this.state.loader) {
      return (
        <div class="area-loader">
          <div class="loader"></div>
        </div>
      );
    }
    var product = this.state.data.products;
    var invoicingType = {
      1: "Diária",
      2: "Semanal",
      3: "Quizenal",
      4: "Mensal",
      5: "Anual",
    };
    var billing = {
      1: "day_price",
      2: "weekly_price",
      3: "biweekly_price",
      4: "monthly_price",
      5: "annual_price",
    };
    var type_billing = {
      day_price: "Diária",
      weekly_price: "Semanal",
      biweekly_price: "Quizenal",
      monthly_price: "Mensal",
      annual_price: "Anual",
    };
    var endDay = this.endDay();
    return (
      <>
        <div class="content">
          <div class="card">
            <div class="card-header d-flex align-items-center justify-content-between">
              <strong>Renovar Locação de: {this.state.data.client_name}</strong>
              {this.state.data.ref != undefined ? (
                <>
                  {" "}
                  <Link to="history" class="btn btn-primary">
                    <FontAwesomeIcon icon={faHistory} /> Histórico
                  </Link>
                </>
              ) : (
                <>
                  <button disabled class="btn btn-primary">
                    <FontAwesomeIcon icon={faHistory} /> Histórico
                  </button>
                </>
              )}
            </div>
            <div class="card-body">
              <table className="table table-striped table-bordered arvore-l mt-2">
                <thead className="thead-dark">
                  <tr>
                    <th>Código de Barras</th>
                    <th>Nome</th>
                    <th>Faturamento</th>
                    <th>Quantidade</th>
                    <th>Período</th>
                    <th>Valor Unitário</th>
                    <th>Valor Total</th>
                  </tr>
                </thead>
                <tbody>
                  {product.map((product) => {
                    return (
                      <tr key={product.codigo_barra}>
                        <td>{product.codigo_barra}</td>
                        <td>{product.name}</td>
                        <td>{invoicingType[this.state.data.billing]}</td>
                        <td>{product.quantiny}</td>
                        <td>{this.state.data.rental_period}</td>
                        <td>
                          {product[
                            billing[this.state.data.billing]
                          ].toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </td>
                        <td>
                          {(
                            product.quantiny *
                            product[billing[this.state.data.billing]]
                          ).toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </td>
                      </tr>
                    );
                  })}

                  {/* Linha do valor total */}
                  <tr>
                    <td colspan="5"></td>
                    <td style={{ textAlign: "center" }}>
                      {/* Cálculo do valor total */}
                      {product
                        .reduce((total, product) => {
                          return (
                            total +
                            product.quantiny *
                              product[billing[this.state.data.billing]]
                          );
                        }, 0)
                        .toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        })}
                    </td>
                    <td>
                      {this.state.data.location_value.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })}
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="row mb-3">
                <div class="col-md-2">
                  <TextField
                    select
                    label="Faturamento"
                    id="faturamento"
                    name="faturamento"
                    fullWidth
                    value={this.state.dados.faturamento || ""}
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        dados: {
                          ...prevState.dados,
                          ["faturamento"]: e.target.value,
                        },
                      }));
                    }}
                  >
                    <MenuItem value="1">Diária</MenuItem>
                    <MenuItem value="2">Semanal</MenuItem>
                    <MenuItem value="3">Quinzenal</MenuItem>
                    <MenuItem value="4">Mensal</MenuItem>
                    <MenuItem value="5">Anual</MenuItem>
                  </TextField>
                </div>

                <div class="col-md-2">
                  <TextField
                    label="Qtd. Período Adicional"
                    fullWidth
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    type="text"
                    onChange={(e) => {
                      var value = e.target.value.replace(/\D/g, "");

                      this.setState((prevState) => ({
                        dados: {
                          ...prevState.dados,
                          ["period"]: new Number(value),
                        },
                      }));
                    }}
                    value={this.state.dados.period || 0}
                    disabled={0}
                  />
                </div>

                <div class="col-md-2">
                  <TextField
                    label="Data Inicial"
                    fullWidth
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    type="datetime-local"
                    id="data-inicial"
                    required=""
                    value={this.state.data.start_day.slice(0, 16)}
                    disabled={true}
                  />
                </div>

                <div class="col-md-2">
                  <TextField
                    label="Data de Vencimento"
                    fullWidth
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    type="datetime-local"
                    id="data-final-renovacao"
                    value={this.state.data.end_day.slice(0, 16)}
                    required=""
                    disabled={true}
                  />
                </div>

                <div class="col-md-2">
                  <TextField
                    label="Data da Renovação"
                    fullWidth
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    type="datetime-local"
                    id="data-final-renovacao"
                    value={this.state.data.end_day.slice(0, 16)}
                    required=""
                    disabled={true}
                  />
                </div>
                <div class="col-md-2">
                  <TextField
                    label="Data Final"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    type="datetime-local"
                    id="data-final"
                    value={
                      this.state.dados.faturamento !== undefined &&
                      this.state.dados.period > 0
                        ? endDay
                        : 0
                    }
                    required=""
                    disabled={true}
                  />
                </div>
              </div>
              <div className="row">
                <div class="col-md-2">
                  <TextField
                    select
                    label="Forma de Pagamento"
                    fullWidth
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    id="payment_type"
                    name="payment_type"
                    onChange={(e) => {
                      this.setState((prevState) => ({
                        dados: {
                          ...prevState.dados,
                          ["payment_type"]: e.target.value,
                        },
                      }));
                    }}
                    value={this.state.dados.payment_type || ""}
                  >
                    <MenuItem value="boletop">Boleto</MenuItem>
                    <MenuItem value="cartaoc">Cartão de Crédito</MenuItem>
                    <MenuItem value="cartaod">Cartão de Débito</MenuItem>
                    <MenuItem value="dinheiro">Dinheiro</MenuItem>
                    <MenuItem value="pix">PIX</MenuItem>
                  </TextField>
                </div>

                <div className="col-md-2">
                  <TextField
                    label="Multa"
                    fullWidth
                    InputProps={{
                      style: {
                        height: 45,
                        padding: "0 5px",
                      },
                    }}
                    type="text"
                    onChange={(e) => {
                      var value = e.target.value.replace(/\D/g, "");

                      this.setState((prevState) => ({
                        dados: {
                          ...prevState.dados,
                          ["fine"]: this.formatarMoeda(e.target.value), // Atualiza apenas o campo correspondente
                        },
                      }));
                    }}
                    value={this.state.dados.fine || "R$ 0,00"}
                  />
                </div>
              </div>

              <div class="row mb-3 d-flex align-items-center"></div>

              {this.state.dados.faturamento !== undefined &&
                this.state.dados.period > 0 && (
                  <table className="table table-striped table-bordered arvore-l mt-2">
                    <thead className="thead-dark">
                      <tr>
                        <th>Código de Barras</th>
                        <th>Nome</th>
                        <th>Faturamento</th>
                        <th>Quantidade</th>
                        <th>Valor Unitário</th>
                        <th>Valor Total</th> {/* Nova coluna "Valor Total" */}
                        <th>Ação</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.renew.map((product) => {
                        // Acessa o preço de acordo com o tipo de faturamento
                        const unitPrice =
                          product[billing[this.state.dados.faturamento]];

                        // Ajusta o preço de acordo com o período
                        const adjustedPrice =
                          unitPrice * this.state.dados.period;

                        // Calcula o valor total (quantidade * preço ajustado)
                        const totalValue = adjustedPrice * product.quantiny;

                        return (
                          <tr key={product.codigo_barra}>
                            <td className={product.block === 1 ? "dsb" : ""}>
                              {product.codigo_barra}
                            </td>
                            <td className={product.block === 1 ? "dsb" : ""}>
                              {product.name}
                            </td>
                            <td className={product.block === 1 ? "dsb" : ""}>
                              {invoicingType[this.state.dados.faturamento]}
                            </td>
                            <td className={product.block === 1 ? "dsb" : ""}>
                              <input
                                type="number"
                                className="form-control"
                                value={product.quantiny}
                                onChange={(e) => {
                                  this.setState((prevState) => ({
                                    renew: prevState.renew.map((item) => {
                                      if (item.id === product.id) {
                                        return {
                                          ...item,
                                          quantiny: e.target.value,
                                        };
                                      }
                                      return item;
                                    }),
                                  }));
                                }}
                              />
                            </td>
                            <td className={product.block === 1 ? "dsb" : ""}>
                              {product[
                                billing[this.state.dados.faturamento]
                              ].toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })}
                            </td>
                            <td className={product.block === 1 ? "dsb" : ""}>
                              {totalValue.toLocaleString("pt-BR", {
                                style: "currency",
                                currency: "BRL",
                              })}
                            </td>
                            <td>
                              <button
                                className={
                                  product.block === 1
                                    ? "btn btn-primary"
                                    : "btn btn-danger"
                                }
                                onClick={() => {
                                  var id = product.id;

                                  this.setState((prevState) => ({
                                    renew: prevState.renew.map((item) => {
                                      if (item.id === id) {
                                        // Se o campo idade não existir, criamos com o valor 1
                                        if (item.block === undefined) {
                                          return { ...item, block: 1 };
                                        }
                                        // Caso contrário, alternamos entre 1 e 0
                                        return {
                                          ...item,
                                          block: item.block === 1 ? 0 : 1,
                                        };
                                      }
                                      return item;
                                    }),
                                  }));
                                }}
                              >
                                <FontAwesomeIcon
                                  icon={
                                    product.block === 1 ? faRefresh : faTrash
                                  }
                                />
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td colspan="4"></td>
                        <td style={{ textAlign: "center" }}>
                          {/* Cálculo do valor total de todos os produtos */}

                          {this.state.renew
                            .reduce((total, product) => {
                              if (product.block === 1) {
                                return total; // Se block for 1, não adiciona o valor ao total
                              }
                              const unitPrice =
                                product[billing[this.state.dados.faturamento]];
                              const adjustedPrice =
                                unitPrice * this.state.dados.period;
                              const totalValue =
                                adjustedPrice * product.quantiny;
                              return total + totalValue;
                            }, 0)
                            .toLocaleString("pt-BR", {
                              style: "currency",
                              currency: "BRL",
                            })}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                )}
            </div>

            <div
              className="card-footer"
              style={{ display: "flex", justifyContent: "flex-end" }}
            >
              <button
                className="btn btn-primary"
                disabled={
                  this.state.dados.faturamento !== undefined &&
                  this.state.dados.period > 0
                    ? false
                    : true
                }
                onClick={(e) => {
                  var total = this.state.renew.reduce((total, product) => {
                    if (product.block === 1) {
                      return total;
                    }
                    const unitPrice =
                      product[billing[this.state.dados.faturamento]];
                    const adjustedPrice = unitPrice * this.state.dados.period;
                    const totalValue = adjustedPrice * product.quantiny;
                    return total + totalValue;
                  }, 0);

                  if (this.state.dados.faturamento == undefined) {
                    toast.warn("Selecione  o tipo de faturamento");

                    return;
                  }
                  if (this.state.dados.payment_type == undefined) {
                    toast.warn("Selecione  a forma de pagamento");
                    return;
                  }

                  const filteredProducts = this.state.renew.filter(
                    (product) => product.block !== 1
                  );

                  var dates = {
                    1: 1,
                    2: 7,
                    3: 15,
                    4: 30,
                    5: 365,
                  };
                  function formatDate(isoString) {
                    var date = new Date(isoString);
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, "0");
                    const day = String(date.getDate()).padStart(2, "0");
                    const hours = String(date.getHours()).padStart(2, "0");
                    const minutes = String(date.getMinutes()).padStart(2, "0");

                    return `${year}-${month}-${day} ${hours}:${minutes}`;
                  }
                  const date = new Date();
                  var dias =
                    this.state.dados.period !== undefined
                      ? this.state.dados.period *
                        dates[this.state.dados.faturamento]
                      : 0;
                  var end_renew = date.setDate(date.getDate() + dias);

                  const produtosNormalizados = this.state.renew.map(
                    (produto) => ({
                      ...produto,
                      block: produto.block !== undefined ? produto.block : 0,
                    })
                  );
                  const check = produtosNormalizados.some(
                    (produto) => produto.block === 0
                  );

                  if (!check) {
                    toast.warn("Nenhum produto selecionado");
                    return;
                  }

                  e.target.classList.add("load");

                  fetch(`${apiUrl}/renew-leaser/${this.props.params.token}`, {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      authorization: localStorage.getItem("token"),
                    },
                    body: JSON.stringify({
                      dados: {
                        id: this.state.data.id,
                        token: this.state.data.token,
                        ref: this.state.data.ref,
                        original_value: this.state.data.location_value,
                        client_id: this.state.data.client_id,
                        client_name: this.state.data.client_name,
                        seller_name: this.state.data.seller_name,
                        obs: this.state.data.obs,
                        billing: this.state.dados.faturamento,
                        fine: this.state.dados.fine,
                        period: this.state.dados.period,
                        shipping_cost: this.state.data.shipping_cost,
                        payment_type: this.state.dados.payment_type,
                        total: total.toLocaleString("pt-BR", {
                          style: "currency",
                          currency: "BRL",
                        }),
                        start_day: formatDate(this.state.data.end_day),
                        end_renew: endDay,
                      },
                      products: produtosNormalizados,
                      ref: this.state.data.ref,
                    }),
                  })
                    .then((response) => {
                      e.target.classList.remove("load");

                      toast.success("A renovação foi realizada com sucesso");
                      this.props.navigate("/financeiro");
                    })
                    .catch((error) => {
                      e.target.classList.remove("load");
                      //  toast.error("Erro ao salvar a renovação");
                    });
                }}
              >
                <FontAwesomeIcon icon={faSave} /> Salvar
              </button>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withLocation(ReNewLeaser);
